import React, { lazy } from 'react';
import { BrowserRouter as Router, Redirect, Route, useLocation } from 'react-router-dom';
import { Loading } from '@guryou/html-components';
import AiStudio from 'aiStudio';
import Header from 'components/navigation/Header';
import { SidebarAdminProvider } from 'components/navigation/SidebarAdminContext';

const Admin = lazy(() => import('./admin'));
const Business = lazy(() => import('./business'));
const Providers = lazy(() => import('./providers'));

const ConditionalHeader = () => {
  const location = useLocation();
  const isAdmin = location.pathname.includes('/admin');

  if (isAdmin) {
    return null;
  }

  return <Header />;
};

const Modules = () => {
  return (
    <>
      <Router>
        <Loading />
        <SidebarAdminProvider>
          <ConditionalHeader />
          <Route path="/admin" component={Admin} />
          <Route path="/management" component={Business} />
          <Route path="/providers/:providerId" component={Providers} />
          <Route path="/guryou-ai-studio" component={AiStudio} />
          <Route exact path="/" render={() => <Redirect to="/management/providers" />} />
        </SidebarAdminProvider>
      </Router>
    </>
  );
};
export default Modules;
